const WISHLIST_KEY = "wishlist";

/* =====================
   Visitor ID
===================== */

function getVisitorId() {
  let id = localStorage.getItem("visitor_id");

  if (!id) {
    id = "v_" + Math.random().toString(36).substring(2) + Date.now();
    localStorage.setItem("visitor_id", id);
  }

  return id;
}

/* =====================
   Helpers
===================== */

function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]").map(Number);
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  document.dispatchEvent(new CustomEvent("wishlist:updated"));
}

/* =====================
   Stop Dawn card navigation
===================== */

document.addEventListener("mousedown", (e) => {
  const btn = e.target.closest(".wishlist-button");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
});

/* =====================
   Toggle wishlist (CAPTURE PHASE)
===================== */

document.addEventListener(
  "click",
  (e) => {
    const btn = e.target.closest(".wishlist-button");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const productId = Number(btn.dataset.productId);
    const productTitle = btn.dataset.productTitle || "";
    const productHandle = btn.dataset.productHandle || "";

    let list = getWishlist();
    let action = "add";

    if (list.includes(productId)) {
      list = list.filter(id => id !== productId);
      btn.classList.remove("active");
      action = "remove";
    } else {
      list.push(productId);
      btn.classList.add("active");
      action = "add";
    }

    saveWishlist(list);

    /* =====================
       🔥 TRACK TO SERVER
    ====================== */

    fetch("https://wishlist-server-ppmd.onrender.com/wishlist/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitorId: getVisitorId(),
        productId: productId,
        productTitle: productTitle,
        productHandle: productHandle,
        action: action,
        loggedIn: window.SHOPIFY_LOGGED_IN || false
      })
    }).catch(err => console.error("Tracking failed:", err));

    console.log("Wishlist:", list);
  },
  true // 👈 capture phase (beats Dawn)
);

/* =====================
   Restore state on load
===================== */

document.addEventListener("DOMContentLoaded", () => {
  const list = getWishlist();

  document.querySelectorAll(".wishlist-button").forEach(btn => {
    const id = Number(btn.dataset.productId);
    if (list.includes(id)) {
      btn.classList.add("active");
    }
  });
});
